import API from './fetch'
import { searchRoomURL, getRoomsInfoURL, recommendationRoomURL, roomPriceUrl } from './url'
import { appendParams } from 'utilities/paramsFormat'
import _pickBy from 'lodash/pickBy'
import _identity from 'lodash/identity'
import { ROOMS_POST_THRESHOLD } from 'constants/reservation'

const Rooms = {
  get(params) {
    const url = appendParams(searchRoomURL(), params)
    return API.getData(url)
  },
  getSelectedData(payload) {
    const body = {
      ...payload,
      coupon_code: payload.coupon_code || payload.voucher_coupon_code,
      include_extra_out_of_stock: true
    }
    if ((payload.rooms?.length ?? 0) > ROOMS_POST_THRESHOLD) {
      return API.postData(getRoomsInfoURL(), body)
    }
    return API.getData(appendParams(getRoomsInfoURL(), body))
  },
  getRecommendation(payload) {
    const url = appendParams(recommendationRoomURL(), payload)
    return API.getData(url)
  },
  getPrice(id, payload) {
    const url = appendParams(roomPriceUrl(id), payload)
    return API.getData(url)
  }
}

export default Rooms
